mutation UpdateDocumentMutation($id: ID!, $input: UpdateDocumentInput!) {
  updateDocument(id: $id, input: $input) {
    id
    title
    slug
    type
    isPublished
  }
}
